import Axios from "axios";

const base_url = "cp/customers";

export default {
    /**
     * Display a listing of the Customers.
     *
     * @param {int} page number of page for pagination
     * @param {object} params filter (search) options
     * @returns {Promise}
     */
    getAll(page = 1, params = {}) {
        return Axios.get(`${base_url}?page=${page}`, { params });
    },

    /**
     * Store a new Customer in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    create(data) {
        return Axios.post(base_url, data);
    },

    /**
     * Show data for a given customer.
     *
     * @param {int} id
     * @param {boolean} withProducts return products of customer or not
     * @returns {Promise}
     */
    getById(id, withProducts = false) {
        return Axios.get(`${base_url}/${id}`, { params: { withProducts } });
    },

    /**
     * Update the given Customer in server.
     *
     * @param {object} data item properties
     * @returns {Promise}
     */
    update(data) {
        return Axios.put(`${base_url}/${data.id}`, data);
    },

    /**
     * Remove the specified Customer from server.
     *
     * @param {int} id
     * @returns {Promise}
     */
    delete(id) {
        return Axios.delete(`${base_url}/${id}`);
    }
};
